import { createRouter, createWebHistory } from "vue-router";
import modulesRoutes from "./modules";
import constRoutes from "./constRoutes";

function isEmpty(obj) {
  if (
    typeof obj === "undefined" ||
    obj === null ||
    obj === "" ||
    obj === "0" ||
    obj === false ||
    obj === 0 ||
    obj === []
  ) {
    return true;
  } else {
    return false;
  }
}
const routes = [...modulesRoutes, ...constRoutes];

const router = createRouter({
  history: createWebHistory(process.env.localenv.BASE),
  routes,
});

// 动态添加路由的方法
export const addRoutes = (menus) => {
  // 是否有新的路由
  let hasNewRoute = false;
  // 从动态路由中找菜单
  const findRoute = (menuArr) => {
    // 遍历每个菜单
    menuArr.forEach((menu) => {
      // 从动态路由中找到和菜单的路径相同的路由
      let route = modulesRoutes.find((route) => route.path === menu.url_path);
      // 如果找到了，且没有注册过
      if (route && !router.hasRoute(route.name)) {
        if (route.meta && route.meta.level && route.meta.level === 1) {
          // 添加一级路由
          router.addRoute(route);
        } else {
          // 添加子路由
          router.addRoute("Layout", route);
        }
        hasNewRoute = true;
      }
      // 如果还有嵌套路由
      if (menu.children && menu.children.length > 0) {
        findRoute(menu.children);
      }
    });
  };
  // 为菜单动态添加路由
  findRoute(menus);
  // 返回
  return hasNewRoute;
};

router.beforeEach((to, from, next) => {
  console.log(to, "----------");
  document.documentElement.scrollTop = 0;
  if (isEmpty(history.state.current)) {
    Object.assign(history.state, { current: from.fullPath });
  }
  if (!to.query) {
    next({ ...to, query: { ...to.query } });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // to.query.t = Date.now()
  if (to.path !== "/projectDetiil") {
    document.title = "SANY UK";
  }
  if (to.query.source) {
    sessionStorage.setItem("sourceVal", to.query.source);
  }
});
export default router;
